var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StringUtils } from '../../utils';
import { Label } from '../Label';
export var SectionLabel = function (props) { return (_jsxs("div", __assign({ className: StringUtils.combineStrings(['localina-section-label', props.extraClassName]) }, { children: [_jsx(Label, { type: "label", value: props.value }), props.action && _jsx("div", __assign({ className: "localina-section-label__action" }, { children: props.action }))] }))); };
